<template>
	<div :class="`relative ${full ? 'w-full grow' : 'w-fit'}`">
		<a :class="`${full ? 'w-full' : 'w-fit'}`" @click.stop="toggleDropdown(id)">
			<slot name="button"/>
		</a>
		<DropdownContainer :id="id" :right="right" :up="up">
			<slot/>
		</DropdownContainer>
	</div>
</template>
<script setup lang="ts">
import {defineProps, ref, type Ref} from 'vue'
import {toggleDropdown} from '@/Helpers/general'
import DropdownContainer from '@/Components/UI/Dropdown/DropdownContainer.vue'

const props = defineProps<{
	id:string,
	up?:boolean,
	full?:boolean,
	right?:boolean,
}>()

const id:Ref<string> = ref(props.id)
const up:Ref<boolean> = ref(props.up)
const right:Ref<boolean> = ref(props.right)
</script>